import {EntityState} from '@modifi/redux/lib/esm/factories/entity/reducer'
import reducer from './entity'

export default reducer

// @ts-expect-error to be fixed
export type BankUtilsState = EntityState<any>
